import { Component, OnInit } from '@angular/core';
import { TerrainGridService } from 'src/app/services/terrain-grid.service';
import { ToolsControlService } from 'src/app/services/tools-control.service';
import { MenuManagementService } from 'src/app/menu/services/menu-management.service';
import { TabsService } from 'src/app/services/tabsService';

@Component({
  selector: 'app-terrain-grid',
  templateUrl: './terrain-grid.component.html',
  styleUrls: ['./terrain-grid.component.scss'],
  standalone: false
})
export class TerrainGridComponent implements OnInit {

  constructor(
    public terrainGridController : TerrainGridService,
    public toolsService : ToolsControlService,
    public menuController : MenuManagementService,
    public tabsService: TabsService
  ) { }

  ngOnInit(): void {
  }

  cancelWindow():void{
    this.terrainGridController.active = !this.terrainGridController.active;
    this.toolsService.navigationOnTop = false;
  }

}
